import React from 'react';
import { Icon, Message } from 'semantic-ui-react';
import styled from 'styled-components';

const MessageWrapper = styled.div`
  text-align: center;
`;

const StyledMessage = styled(Message)`
  border: none;
  background-color: white !important;
  width: 45em !important;
  text-align: left;
  box-shadow: none !important;
`;

const ErrorPage = () => (
    <MessageWrapper>
      <StyledMessage icon error compact>
        <Icon name="warning"/>
        <Message.Content>
          <Message.Header>Unexpected error</Message.Header>
          Something unexpected happened.Please contact us at <a href="mailto:contact@support.codelogiq.com">contact@support.codelogiq.com</a>
        </Message.Content>
      </StyledMessage>
    </MessageWrapper>
);

export default ErrorPage;
